import React, { useState } from 'react'

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Divider,
  Typography,
  Button,
} from '@material-ui/core'

import * as service from 'service'
import helpers from 'helpers'

import useSnackbar from 'hooks/useSnackbar'

const DialogDestroy = ({
  integrationId,
  open,
  setOpen = () => {},
  onEvent = () => {},
}) => {
  const snackbar = useSnackbar()
  const [loading, setLoading] = useState(false)

  const destroy = async () => {
    setLoading(true)
    try {
      await service.dponet.externalPlatformIntegrations.destroy({
        integrationId,
      })
      snackbar.open({
        message: 'Integração excluída com sucesso!',
        variant: 'success',
      })
      onEvent()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Ocorreu um erro ao excluir a integração.',
        variant: 'error',
      })
    } finally {
      setOpen(false)
      setLoading(false)
    }
  }

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>
        <Box>
          <Typography variant="h4">Excluir integração</Typography>
        </Box>
      </DialogTitle>
      <Divider />
      <Box mb={1}>
        <DialogContent>
          <Typography>
            Tem certeza que deseja excluir esta integração? Essa ação não pode
            ser desfeita.
          </Typography>
        </DialogContent>
      </Box>
      <Divider />
      <DialogActions>
        <Box pl={2} pr={1}>
          <Button
            disabled={loading}
            type="button"
            variant="outlined"
            onClick={() => setOpen(false)}
          >
            Cancelar
          </Button>
        </Box>
        <Button
          disabled={loading}
          variant="contained"
          type="submit"
          color="primary"
          onClick={destroy}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialogDestroy
